import {
  Box,
  Button,
  Center,
  Flex,
  Link,
  Stack,
  Tag,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import axios from 'axios';
import IconBox from 'components/Icons/IconBox';
import { Separator } from 'components/Separator/Separator';
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

// this function creates the links and collapses that appear in the sidebar (left menu)

const SidebarContent = ({ logoText, routes }) => {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  const [newEstimate, setNewEstimate] = useState(false);
  const [newContract, setNewContract] = useState(false);
  const [newContact, setNewContact] = useState(false);
  const [newAdvertiseOrder, setNewAdvertiseOrder] = useState(false);
  const [newAfterService, setNewAfterService] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const { data } = await axios.get(
        '/estimates/admin-left-menu-notification',
      );

      setNewEstimate(data.estimate);
      setNewContract(data.contract);
      setNewContact(data.contact);
      setNewAdvertiseOrder(data.advertiseOrder);
      const { data: afterServiceData } = await axios.get(
        '/after-services/admin-left-menu-notification',
      );
      setNewAfterService(afterServiceData);
    };
    getData();
  }, [location]);

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };
  const createLinks = (routes) => {
    // Chakra Color Mode
    const activeBg = useColorModeValue('white', 'gray.700');
    const inactiveBg = useColorModeValue('white', 'gray.700');
    const activeColor = useColorModeValue('gray.700', 'white');
    const inactiveColor = useColorModeValue('gray.400', 'gray.400');

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        var st = {};
        st[prop['state']] = !state[prop.state];
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mx="auto"
              ps={{ sm: '10px', xl: '16px' }}
              py="12px"
            >
              {prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          {activeRoute(prop.layout + prop.path) === 'active' ? (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg={activeBg}
              mb={{
                xl: '12px',
              }}
              mx={{
                xl: 'auto',
              }}
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              py="12px"
              borderRadius="15px"
              w="100%"
              _active={{
                bg: 'inherit',
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{
                boxShadow: 'none',
              }}
            >
              <Flex>
                {typeof prop.icon === 'string' ? (
                  <>{prop.icon}</>
                ) : (
                  <IconBox
                    bg="red.300"
                    color="white"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={activeColor} my="auto" fontSize="sm">
                  {document.documentElement.dir === 'rtl'
                    ? prop.rtlName
                    : prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize="initial"
              justifyContent="flex-start"
              alignItems="center"
              bg="transparent"
              mb={{
                xl: '12px',
              }}
              mx={{
                xl: 'auto',
              }}
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              borderRadius="15px"
              w="100%"
              _active={{
                bg: 'inherit',
                transform: 'none',
                borderColor: 'transparent',
              }}
              _focus={{
                boxShadow: 'none',
              }}
            >
              <Flex>
                {typeof prop.icon === 'string' ? (
                  <>{prop.icon}</>
                ) : (
                  <IconBox
                    bg={inactiveBg}
                    color="red.300"
                    h="30px"
                    w="30px"
                    me="12px"
                  >
                    {prop.icon}
                  </IconBox>
                )}
                <Center>
                  <Text color={inactiveColor} my="auto" fontSize="sm">
                    {document.documentElement.dir === 'rtl'
                      ? prop.rtlName
                      : prop.name}
                  </Text>
                  {prop.name === '견적서' && newEstimate && (
                    <Tag size="sm" ml="5px" colorScheme="teal">
                      확인필요
                    </Tag>
                  )}
                  {prop.name === 'A/S 관리' && newAfterService && (
                    <Tag size="sm" ml="5px" colorScheme="teal">
                      확인필요
                    </Tag>
                  )}
                  {prop.name === '판매 내역' && newAdvertiseOrder && (
                    <Tag size="sm" ml="5px" colorScheme="teal">
                      확인필요
                    </Tag>
                  )}
                  {prop.name === '제휴문의' && newContact && (
                    <Tag size="sm" ml="5px" colorScheme="teal">
                      확인필요
                    </Tag>
                  )}
                  {prop.name === '계약서' && newContract && (
                    <Tag size="sm" ml="5px" colorScheme="teal">
                      확인필요
                    </Tag>
                  )}
                </Center>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  return (
    <>
      <Box pt={'25px'} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/admin/dashboard`}
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          justifyContent="center"
          alignItems="center"
          fontSize="11px"
        >
          <Center>
            <img
              src="https://beam-monster-backend.s3.ap-northeast-2.amazonaws.com/logo_img.png"
              width={16}
            />
            <Text fontSize="sm" ml="3px">
              {logoText}
            </Text>
          </Center>
        </Link>
        <Separator></Separator>
      </Box>
      <Stack direction="column" mb="40px">
        <Box>{links}</Box>
      </Stack>
    </>
  );
};

export default SidebarContent;
